export const RENEW_CARD_FILE_INIT_VALUES = {
	member_type: '',
	card_on_file: ''
};

export const RENEW_NEW_CARD_INIT_VALUES = {
	plan_type: '',
	first_name: '',
	last_name: '',
	email: '',
	save_card_information: true
};

export const RENEW_USER_PAYMENT_FORM = {
	plan_type: '',
	first_name: '',
	last_name: '',
	email: '',
	save_card_information: true
};
